<template>
  <div>
    <h1>Telemetry</h1>

    <div class="row mb-3">
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <label class="form-label">Date Format</label>
        <select class="form-select" v-model="format">
          <option v-for="f in formats" :key="f.format" :value="f.format">{{ f.label }}</option>
        </select>
      </div>
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <label class="form-label">Context</label>
        <select class="form-select" v-model="context">
          <option value="">Any Context</option>
          <option v-for="c in contexts" :key="c" :value="c">{{ c }}</option>
        </select>
      </div>
      <div class="col-12 col-md-4">
        <label class="form-label">Event Type</label>
        <select class="form-select" v-model="type">
          <option value="">Any Event Type</option>
          <option v-for="t in types" :key="t" :value="t">{{ t }}</option>
        </select>
      </div>
    </div>
    <transition mode="out-in">
      <div v-if="loading"><loading-spinner /></div>
      <div v-else class="overflow-auto">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Date</th>
            <th>Unique Users</th>
            <th>Unique eShops</th>
            <th>Total Views</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="d in data" :key="d.date">
            <td>{{ d.date }}</td>
            <td>{{ d.distinct_users }}</td>
            <td>{{ d.distinct_eshops }}</td>
            <td>{{ d.views }}</td>
          </tr>
          </tbody>
        </table>


      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import LoadingSpinner from "@/app/components/Utils/LoadingSpinner.vue";

const loading = ref(true);
const data = ref(null);
const type = ref('view')
const context = ref('Insights')
const format = ref('%X Week %V')
const store = useStore();

const types = ['view','date_range_changed']
const contexts = ['Insights','NewOrders','TopOrders', 'Inventory']
const formats = [
  {label:'Y WEEK', format: '%X Week %V'},
  {label:'Y-M-D', format: '%Y-%m-%d'},
  {label:'Y-M', format: '%Y-%m'},
]

watch(type, () => runReport())
watch(context, () => runReport())
watch(format, () => runReport())

async function runReport() {
  const response = await store.state.api.get('/admin/telemetry/', { params:
        {type: type.value, context: context.value, format: format.value}
  })
  data.value = response.data?.report || [];
  loading.value = false;
}

onMounted(async () => {
  await runReport();
})

</script>